<template lang="html">
  <div>
    <v-form v-model="formularioValido" ref="form">
      <v-container>
        <br>

        <v-layout row wrap justify-space-between v-if="administrador === false && ((projeto.funcao != null && projeto.funcao.item === 1 && projeto.situacao.item === 18) || (projeto.assessor === true && projeto.situacao.item === 18))">
          <v-flex xs12>
            <div class="center">
              <v-card outlined>
                <v-card-text class="black--text font-weight-bold">
                  Como a ação de extensão está na situação "Ativo", é possível alterar apenas os campos "Objetivos específicos" e "Informações adicionais".
                </v-card-text>
              </v-card>
            </div>
          </v-flex>
        </v-layout>

        <p class="mt-3"></p>

        <v-layout row wrap justify-center>
          <v-flex xs8>
            <v-select
              v-if="administrador === true"
              :items="listaUnidades"
              eager
              item-text="nomeSigla"
              item-value="id"
              label="Unidade"
              return-object
              v-model="extensao.unidade"
              autocomplete
              required
            ></v-select>
            <v-select
              v-else
              :items="listaUnidades"
              item-text="nomeSigla"
              item-value="id"
              label="Unidade"
              return-object
              v-model="extensao.unidade"
              readonly
              autocomplete
              required
              :disabled="administrador !== true && projeto.situacao.item !== 15"
            ></v-select>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center>
          <v-flex xs8>
            <v-select
              :items="listaCoordenadoPor"
              item-text="descricao"
              item-value="item"
              return-object
              label="Coordenado por"
              v-model="extensao.coordenadoPor"
              :disabled="administrador !== true && projeto.situacao.item !== 15"
            ></v-select>
          </v-flex>
        </v-layout>

        <v-layout v-if="extensao.evento" row wrap justify-center>
          <v-flex xs8>
            <v-select
              :items="listaTipoEvento"
              item-text="descricao"
              item-value="item"
              return-object
              label="Tipo de Evento"
              v-model="extensao.tipoEvento"
              :disabled="administrador !== true && projeto.situacao.item !== 15"
            ></v-select>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center>
          <v-flex xs8>
            <v-text-field
              label="Data da primeira apresentação"
              v-model="extensao.dtPrimeiraApresentacao"
              type="date"
              :disabled="administrador !== true && projeto.situacao.item !== 15"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <!-- O programa é uma Empresa Júnior? -->
        <v-layout v-if="projeto.classificacaoSecundaria.id === 39733" row wrap justify-center>
          <v-flex xs8>
            <v-select
              :items="itensCampoEmpresaJunior"
              item-text="descricao"
              item-value="item"
              label="O programa é uma Empresa Júnior?"
              v-model="extensao.empresaJunior"
              :disabled="administrador !== true && projeto.situacao.item !== 15"
            ></v-select>
          </v-flex>
        </v-layout>

        <!-- Texto informativo sobre o cadastro de empresas juniores como programas -->
        <v-layout v-if="projeto.classificacaoSecundaria.id === 39733" row wrap justify-center>
          <v-flex xs8>
            <v-alert
              class="alerta"
              color="#00796b"
              type="info"
              dense
              outlined
            >
              Conforme os Artigos 03, 06 e 10 da Resolução nº.10/2019 do Conselho Universitário, as empresas juniores deverão ser cadastradas na Pró-Reitoria de Extensão – PROEX como Programa de Extensão.
            </v-alert>
          </v-flex>
        </v-layout>

        <p class="mt-3"></p>

        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <c-textarea
              :rows="2"
              :auto-grow="true"
              multi-line counter="2000"
              label="Apresentação"
              v-model="extensao.apresentacao"
              :rules="AreaDeTextoRules2000"
              :disabled="!(administrador === true || (projeto.funcao !== null && projeto.funcao.item === 1))"
            ></c-textarea>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <c-textarea
              :rows="2"
              :auto-grow="true"
              multi-line counter="2000"
              label="Justificativa / Mérito extensionista"
              v-model="extensao.justificativa"
              :rules="AreaDeTextoRules2000"
              :disabled="administrador !== true && projeto.situacao.item !== 15"
            ></c-textarea>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="extensao.caracterizacaoPublicoAlvo">
          <v-flex xs12>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <c-textarea
                    v-on="on"
                    :rows="2"
                    :auto-grow="true"
                    multi-line counter="500"
                    label="Caracterização do público-alvo"
                    v-model="extensao.caracterizacaoPublicoAlvo"
                    :rules="AreaDeTextoRules500"
                    :disabled="administrador !== true && projeto.situacao.item !== 15"
                  ></c-textarea>
                </div>
              </template>
              <span>
                <div>As atividades de extensão devem envolver diretamente as comunidades externas às instituições de ensino superior e estarem vinculadas à formação do estudante (Resolução CNE 07/2018, Art. 7°).</div>
              </span>
            </v-tooltip>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="!extensao.caracterizacaoPublicoAlvo && projeto.tipoPublico.item === 1">
          <v-flex xs12>
            <c-textarea
              v-on="on"
              :rows="2"
              :auto-grow="true"
              multi-line counter="500"
              label="Caracterização do público-alvo interno (membros da comunidade acadêmica)"
              v-model="extensao.publicoAlvoInterno"
              :rules="AreaDeTextoRules500"
              :disabled="administrador !== true && projeto.situacao.item !== 15"
            ></c-textarea>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="!extensao.caracterizacaoPublicoAlvo">
          <v-flex xs12>
            <c-textarea v-on="on" :rows="2" :auto-grow="true" multi-line counter="500"
            label="Caracterização do público-alvo externo (membros da sociedade)" v-model="extensao.publicoAlvoExterno"  :rules="AreaDeTextoRules500"
            :disabled="administrador !== true && projeto.situacao.item !== 15"
            ></c-textarea>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <c-textarea :rows="2" :auto-grow="true" multi-line counter="500"
            label="Objetivo geral" v-model="extensao.objetivosGerais"  :rules="AreaDeTextoRules500"
            :disabled="administrador !== true && projeto.situacao.item !== 15"
            ></c-textarea>
          </v-flex>
        </v-layout>

        <br>
        <v-layout row wrap>
          <v-flex xs12>

            <!-- Objetivos específicos -->
            <label id="label" class="label">Objetivos específicos (Liste os objetivos separadamente em tópicos. Para abrir um novo tópico, clique no ícone +)</label>

            <!-- Lista -->
            <v-list id="label" class="label" two-line dense>

              <!-- Itens (já cadastrados) -->
              <v-list-item v-for="(item, index) in objetivosEspecificosTopicos" :key="item.id" style="padding: 0px;">
                <v-list-item-avatar>
                  {{index+1}}.
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-text-field :auto-grow="true" placeholder="Digite o objetivo específico"
                  v-model="item.nome" :rules="AreaDeTextoRulesN1000"></v-text-field>
                </v-list-item-content>
                <v-list-item-action v-if="administrador === true || (projeto.funcao !== null && projeto.funcao.item === 1)">
                  <c-tooltip-btn icon="remove_circle" color="red" tooltip="Adicionar objetivo específico" @click="objetivosEspecificosTopicos.splice(index, 1)"></c-tooltip-btn>
                </v-list-item-action>
              </v-list-item>

              <!-- Itens (novos) -->
              <v-list-item style="padding: 0px;">
                <v-list-item-action v-if="administrador === true || (projeto.funcao !== null && projeto.funcao.item === 1)">
                  <c-tooltip-btn icon="add_box" color="green" tooltip="Adicionar objetivo específico" @click="objetivosEspecificosTopicos.push({nome: ''})"></c-tooltip-btn>
                </v-list-item-action>
              </v-list-item>

            </v-list>

          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <c-textarea :rows="2" :auto-grow="true" multi-line counter="3000"
            label="Metodologia" v-model="extensao.metodologia"  :rules="AreaDeTextoRules3000"
            :disabled="administrador !== true && projeto.situacao.item !== 15"
            ></c-textarea>
          </v-flex>
        </v-layout>

        <!-- Formas de avaliação -->
        <v-layout row wrap>

          <v-flex xs12>

            <!-- Curso ou Oficina de Extensão -->
            <c-textarea
            :rows="2"
            :auto-grow="true"
            v-if="extensao.curso || extensao.oficina"
            multi-line counter="1000"
            label="Formas de avaliação dos cursistas (descrever os meios avaliativos, o peso das avaliações e a frequência mínima para a aprovação dos cursistas)"
            v-model="extensao.formaAvaliacao"
            :rules="AreaDeTextoRules1000"
            :disabled="!(administrador === true || (projeto.funcao !== null && projeto.funcao.item === 1))"
            ></c-textarea>

            <!-- Demais tipos de ação de extensão -->
            <c-textarea
            v-else
            :rows="2"
            :auto-grow="true"
            multi-line counter="1000"
            label="Forma de avaliação"
            v-model="extensao.formaAvaliacao"
            :rules="AreaDeTextoRules1000"
            :disabled="!(administrador === true || (projeto.funcao !== null && projeto.funcao.item === 1))"
            ></c-textarea>

          </v-flex>

        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <c-textarea :rows="2" :auto-grow="true" multi-line counter="1000"
            label="Infraestrutura física" v-model="extensao.infraestruturaFisica" :rules="AreaDeTextoRules1000"
            :disabled="administrador !== true && projeto.situacao.item !== 15"
            ></c-textarea>
          </v-flex>
        </v-layout>

        <!-- Apresentar justificativa pelo cadastro/envio da ação ter sido realizado em prazo inferior ao estabelecido pela Instrução Normativa nº 02/2016 >
        <v-layout row wrap v-if="this.prazo < 30 && !extensao.registroSIEX">
          <v-flex xs12>
            <c-textarea
            :rows="2"
            :auto-grow="true"
            multi-line counter="500"
            label="Apresentar justificativa pelo cadastro/envio da ação ter sido realizado em prazo inferior ao estabelecido pela Instrução Normativa nº 02/2016"
            v-model="extensao.justificativaPrazo"
            :rules="AreaDeTextoRules1000"
            :disabled="administrador !== true && projeto.situacao.item !== 15"
            ></c-textarea>
          </v-flex>
        </v-layout>
        <v-layout-- row wrap v-if="this.prazo < 30 && !extensao.registroSIEX">
          <v-flex xs12>
            <v-alert
              class="alertaPrazo"
              color="#00796b"
              type="info"
              dense
              outlined
            >
              O coordenador de Ação de Extensão deverá proceder ao registro prévio e encaminhamento da documentação pertinente à PROEX, com antecedência mínima de 30 (trinta) dias úteis ao início da Ação, conforme Instrução Normativa nº 02/2016.
            </v-alert>
          </v-flex>
        </v-layout-->

        <v-layout row wrap>
          <v-flex xs12>
            <c-textarea
              :rows="2"
              :auto-grow="true"
              multi-line
              counter="1000"
              label="Informações adicionais"
              v-model="extensao.informacoesAdicionais"
              :disabled="!(administrador === true || (projeto.funcao !== null && projeto.funcao.item === 1))"
            ></c-textarea>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço -->
        <v-layout row wrap v-if="extensao.prestacaoServico">
          <v-flex xs12>
            <v-select
              v-model="listaTiposPrestacaoServicoSelecionados"
              :items="listaTiposPrestacaoServico"
              chips
              label="Tipo de Prestação de Serviço"
              multiple
            ></v-select>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento ao público em espaços de cultura, ciência e tecnologia) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')">
          <v-flex xs12>
            <p class="tipoPrestacaoServico">Tipo: Atendimento ao público em espaços de cultura, ciência e tecnologia</p>
            <!-- Espaços e Museus Culturais -->
            <v-checkbox
            v-model="listaAtendimentoPublicoEspacosSelecionados"
            value="Espaços e Museus Culturais"
            >
            <template v-slot:label><div>Espaços e Museus Culturais</div></template>
            </v-checkbox>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento ao público em espaços de cultura, ciência e tecnologia) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')">
          <v-flex xs12>
            <!-- Espaços e Museus de Ciência e Tecnologia -->
            <v-checkbox
            v-model="listaAtendimentoPublicoEspacosSelecionados"
            value="Espaços e Museus de Ciência e Tecnologia"
            >
            <template v-slot:label><div>Espaços e Museus de Ciência e Tecnologia</div></template>
            </v-checkbox>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento ao público em espaços de cultura, ciência e tecnologia) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')">
          <v-flex xs12>
            <!-- Cines-clube -->
            <v-checkbox
            v-model="listaAtendimentoPublicoEspacosSelecionados"
            value="Cines-clube"
            >
            <template v-slot:label><div>Cines-clube</div></template>
            </v-checkbox>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento ao público em espaços de cultura, ciência e tecnologia) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')">
          <v-flex xs12>
            <!-- Outros -->
            <v-checkbox
            v-model="listaAtendimentoPublicoEspacosSelecionados"
            value="Outros"
            >
            <template v-slot:label><div>Outros</div></template>
            </v-checkbox>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Serviço eventual) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')">
          <v-flex xs4>
            <p class="tipoPrestacaoServico">Tipo: Serviço eventual</p>
            <!-- Nº de assessorias -->
            <v-text-field
              label='Nº de assessorias'
              v-model="extensao.numAssessorias"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Serviço eventual) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')">
          <v-flex xs4>
            <!-- Nº de consultorias -->
            <v-text-field
              label='Nº de consultorias'
              v-model="extensao.numConsultorias"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Serviço eventual) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')">
          <v-flex xs4>
            <!-- Nº de curadorias -->
            <v-text-field
              label='Nº de curadorias'
              v-model="extensao.numCuradorias"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Serviço eventual) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')">
          <v-flex xs4>
            <!-- Nº de outros -->
            <v-text-field
              label='Nº de outros'
              v-model="extensao.numOutrosServicos"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atividades de propriedade intelectual) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')">
          <v-flex xs4>
            <p class="tipoPrestacaoServico">Tipo: Atividades de propriedade intelectual</p>
            <!-- Nº de depósito de patentes e modelos de utilidades -->
            <v-text-field
              label='Nº de depósito de patentes e modelos de utilidades'
              v-model="extensao.numPatentesModelos"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atividades de propriedade intelectual) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')">
          <v-flex xs4>
            <!-- Nº de registro de marcas e softwares -->
            <v-text-field
              label='Nº de registro de marcas e softwares'
              v-model="extensao.numMarcasSoftwares"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atividades de propriedade intelectual) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')">
          <v-flex xs4>
            <!-- Nº de contratos de transferência de tecnologia -->
            <v-text-field
              label='Nº de contratos de transferência de tecnologia'
              v-model="extensao.numTransferenciaTecnologia"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atividades de propriedade intelectual) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')">
          <v-flex xs4>
            <!-- Nº de registros de direitos autorais -->
            <v-text-field
              label='Nº de registros de direitos autorais'
              v-model="extensao.numDireitosAutorais"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Exames e laudos técnicos) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Exames e laudos técnicos')">
          <v-flex xs4>
            <p class="tipoPrestacaoServico">Tipo: Exames e laudos técnicos</p>
            <!-- Nº de laudos emitidos -->
            <v-text-field
              label='Nº de laudos emitidos'
              v-model="extensao.numLaudosEmitidos"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento jurídico) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento jurídico')">
          <v-flex xs4>
            <p class="tipoPrestacaoServico">Tipo: Atendimento jurídico</p>
            <!-- Nº de atendimentos -->
            <v-text-field
              label='Nº de atendimentos'
              v-model="extensao.numAtendimentosJuridicos"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
          <v-flex xs4>
            <p class="tipoPrestacaoServico">Tipo: Atendimento em saúde humana</p>
            <!-- Nº de consultas ambulatoriais (programadas) -->
            <v-text-field
              label='Nº de consultas ambulatoriais (programadas)'
              v-model="extensao.numConsultasAmbulatoriais"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
          <v-flex xs4>
            <!-- Nº de consultas de emergência e urgência -->
            <v-text-field
              label='Nº de consultas de emergência e urgência'
              v-model="extensao.numConsultasEmergencia"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
          <v-flex xs4>
            <!-- Nº de internações -->
            <v-text-field
              label='Nº de internações'
              v-model="extensao.numInternacoes"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
          <v-flex xs4>
            <!-- Nº de cirurgias -->
            <v-text-field
              label='Nº de cirurgias'
              v-model="extensao.numCirurgias"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
          <v-flex xs4>
            <!-- Nº de exames laboratoriais -->
            <v-text-field
              label='Nº de exames laboratoriais'
              v-model="extensao.numExamesLaboratoriais"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
          <v-flex xs4>
            <!-- Nº de exames complementares -->
            <v-text-field
              label='Nº de exames complementares'
              v-model="extensao.numExamesComplementares"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
          <v-flex xs4>
            <!-- Nº de outros atendimentos -->
            <v-text-field
              label='Nº de outros atendimentos'
              v-model="extensao.numOutrosAtendimentosSH"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde animal) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')">
          <v-flex xs4>
            <p class="tipoPrestacaoServico">Tipo: Atendimento em saúde animal</p>
            <!-- Nº de atendimentos veterinários ambulatoriais -->
            <v-text-field
              label='Nº de atendimentos veterinários ambulatoriais'
              v-model="extensao.numAtendimentosVeterinarios"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde animal) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')">
          <v-flex xs4>
            <!-- Nº de internações veterinárias -->
            <v-text-field
              label='Nº de internações veterinárias'
              v-model="extensao.numInternacoesVeterinarias"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde animal) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')">
          <v-flex xs4>
            <!-- Nº de cirurgias veterinárias -->
            <v-text-field
              label='Nº de cirurgias veterinárias'
              v-model="extensao.numCirurgiasVeterinarias"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Tipo de Prestação de Serviço (Atendimento em saúde animal) -->
        <v-layout row wrap v-if="extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')">
          <v-flex xs4>
            <!-- Nº de exames laboratoriais e complementares em veterinária -->
            <v-text-field
              label='Nº de exames laboratoriais e complementares em veterinária'
              v-model="extensao.numExamesVeterinaria"
              :rules="campoNumericoRules"
              >
            </v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <v-radio-group class="v-radio-group_label" v-model="extensao.vinculoEnsino" label="Possui vínculo com ensino"
              :disabled="administrador !== true && projeto.situacao.item !== 15"
            >
              <v-radio label="Sim" :value="true" ></v-radio>
              <v-radio label="Não" :value="false" ></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex xs12>
            <v-radio-group class="v-radio-group_label" v-model="extensao.vinculoPesquisa" label="Possui vínculo com pesquisa"
              :disabled="administrador !== true && projeto.situacao.item !== 15"
            >
              <v-radio label="Sim" :value="true" ></v-radio>
              <v-radio label="Não" :value="false" ></v-radio>
            </v-radio-group>
          </v-flex>

          <!-- Esta ação realiza divulgação científica -->
          <v-flex xs12>
            <v-radio-group class="v-radio-group_label" v-model="extensao.divulgacaoCientifica" label="Esta ação realiza divulgação científica"
              :disabled="administrador !== true && projeto.situacao.item !== 15"
            >
              <v-radio label="Sim" :value="true" ></v-radio>
              <v-radio label="Não" :value="false" ></v-radio>
            </v-radio-group>
          </v-flex>

          <!-- Esta é uma ação direcionada às escolas públicas -->
          <v-flex xs12>
            <v-radio-group class="v-radio-group_label" v-model="extensao.direcionadaEscolaPublica" label="Esta é uma ação direcionada às escolas públicas (alunos, professores, servidores ou processo de formação continuada)"
              :disabled="administrador !== true && projeto.situacao.item !== 15"
            >
              <v-radio label="Sim" :value="true" ></v-radio>
              <v-radio label="Não" :value="false" ></v-radio>
            </v-radio-group>
          </v-flex>

          <!-- Esta ação será utilizada para a creditação da extensão nos cursos de graduação da UFES -->
          <v-flex xs12 sm5>
            <v-radio-group class="v-radio-group_label" v-model="extensao.creditacaoGraduacao" label="Esta ação será utilizada para a creditação da extensão nos cursos de graduação da UFES"
              :disabled="!(administrador === true || (projeto.funcao !== null && projeto.funcao.item === 1 && projeto.situacao.item === 15))"
            >
              <v-radio label="Sim" :value="true" ></v-radio>
              <v-radio label="Não" :value="false" ></v-radio>
            </v-radio-group>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm5>
            <v-text-field label="Data inicial da creditação" v-model="extensao.dtInicialCreditacao" type="date"
              :disabled="!extensao.creditacaoGraduacao">
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Envolve captação de recursos financeiros ou bens duráveis -->
        <v-layout row wrap center>
          <v-flex xs12>
            <v-radio-group class="v-radio-group_label" v-model="extensao.captacaoRecursosBensDuraveis" label="Envolve captação de recursos financeiros ou bens duráveis"
              :disabled="administrador !== true && projeto.situacao.item !== 15"
            >
              <v-radio label="Sim" :value="true" ></v-radio>
              <v-radio label="Não" :value="false" ></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>

        <!-- Por meio de: -->
        <v-layout row wrap justify-space-between v-if="extensao.captacaoRecursosBensDuraveis === true">
          <v-flex xs12>
            <label>Por meio de:</label>
          </v-flex>
        </v-layout>

        <!-- UFES, CAPES e FEST -->
        <v-layout row wrap center v-if="extensao.captacaoRecursosBensDuraveis === true">

          <!-- UFES -->
          <v-flex xs6 sm2>
            <v-checkbox
            v-model="extensao.captacaoRecursosUfes"
            :disabled="administrador !== true && projeto.situacao.item !== 15"
            >
            <template v-slot:label><div>UFES</div></template>
            </v-checkbox>
          </v-flex>

          <!-- CAPES -->
          <v-flex xs6 sm2>
            <v-checkbox
            v-model="extensao.captacaoRecursosCapes"
            :disabled="administrador !== true && projeto.situacao.item !== 15"
            >
            <template v-slot:label><div>CAPES</div></template>
            </v-checkbox>
          </v-flex>

          <!-- FEST -->
          <v-flex xs6 sm2>
            <v-checkbox
            v-model="extensao.captacaoRecursosFest"
            :disabled="administrador !== true && projeto.situacao.item !== 15"
            >
            <template v-slot:label><div>Fundação de apoio</div></template>
            </v-checkbox>
          </v-flex>

        </v-layout>

        <!-- CNPq, FAPES e FUCAM -->
        <v-layout row wrap center v-if="extensao.captacaoRecursosBensDuraveis === true">

          <!-- CNPq -->
          <v-flex xs6 sm2>
            <v-checkbox
            v-model="extensao.captacaoRecursosCnpq"
            :disabled="administrador !== true && projeto.situacao.item !== 15"
            >
            <template v-slot:label><div>CNPq</div></template>
            </v-checkbox>
          </v-flex>

          <!-- FAPES -->
          <v-flex xs6 sm2>
            <v-checkbox
            v-model="extensao.captacaoRecursosFapes"
            :disabled="administrador !== true && projeto.situacao.item !== 15"
            >
            <template v-slot:label><div>FAPES</div></template>
            </v-checkbox>
          </v-flex>

        </v-layout>

        <!-- Outros e Especifique -->
        <v-layout row wrap center v-if="extensao.captacaoRecursosBensDuraveis === true">

          <!-- Outros -->
          <v-flex xs6 sm2>
            <v-checkbox
            v-model="extensao.captacaoRecursosOutros"
            :disabled="administrador !== true && projeto.situacao.item !== 15"
            >
            <template v-slot:label><div>Outros</div></template>
            </v-checkbox>
          </v-flex>

          <!-- Especifique -->
          <v-flex xs6 sm5 v-if="extensao.captacaoRecursosBensDuraveis === true">
            <v-textarea
            :disabled="extensao.captacaoRecursosOutros !== true || (administrador !== true && projeto.situacao.item !== 15)"
            label="Especifique:"
            v-model="extensao.especCaptacaoRecursosOutros"
            rows="1"
            auto-grow
            counter="200"
            :rules="rules200"
            placeholder=" "
            >
            </v-textarea>
          </v-flex>

        </v-layout>

        <!-- Envolve liberação de carga horária do coordenador aprovada em Departamento/Centro/Setor de lotação -->
        <v-layout row wrap center>
          <v-flex xs12>
            <v-radio-group class="v-radio-group_label" v-model="extensao.liberacaoCargaHoraria" label="Envolve liberação de carga horária do coordenador aprovada em Departamento/Centro/Setor de lotação"
              :disabled="administrador !== true && projeto.situacao.item !== 15"
            >
              <v-radio label="Sim" :value="true" ></v-radio>
              <v-radio label="Não" :value="false" ></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>

        <!-- Carga horária aprovada -->
        <v-layout row wrap center v-if="extensao.liberacaoCargaHoraria === true">
          <v-flex xs2>
            <v-text-field
              :rows="1"
              label="Carga horária aprovada"
              :rules="CargaHorariaCoordenadorAprovadaRules"
              :disabled="administrador !== true && projeto.situacao.item !== 15"
              v-model="extensao.cargaHorariaCoordenadorAprovada"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Gratuito para o público -->
        <v-layout row wrap center v-if="extensao.curso || extensao.oficina || extensao.evento">
          <v-flex xs12>
            <v-radio-group class="v-radio-group_label" v-model="extensao.gratuito" label="Gratuito para o público"
              :disabled="administrador !== true && projeto.situacao.item !== 15"
            >
              <v-radio label="Sim" :value="true" ></v-radio>
              <v-radio label="Não" :value="false" ></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>

        <!-- Os recursos financeiros obtidos serão administrados por: -->
        <v-layout row wrap justify-space-between v-if="extensao.gratuito === false">
          <v-flex xs12>
            <label>Os recursos financeiros obtidos serão administrados por:</label>
          </v-flex>
        </v-layout>

        <!-- UFES -->
        <v-layout row wrap center v-if="extensao.gratuito === false">
          <v-flex xs6 sm2>
            <v-checkbox
            v-model="extensao.gratuitoUfes"
            :disabled="administrador !== true && projeto.situacao.item !== 15"
            >
            <template v-slot:label><div>UFES</div></template>
            </v-checkbox>
          </v-flex>
        </v-layout>

        <!-- FEST-->
        <v-layout row wrap center v-if="extensao.gratuito === false">
          <v-flex xs6 sm2>
            <v-checkbox
            v-model="extensao.gratuitoFest"
            :disabled="administrador !== true && projeto.situacao.item !== 15"
            >
            <template v-slot:label><div>FEST</div></template>
            </v-checkbox>
          </v-flex>
        </v-layout>

        <!-- FUCAM -->
        <v-layout row wrap center v-if="extensao.gratuito === false">
          <v-flex xs6 sm2>
            <v-checkbox
            v-model="extensao.gratuitoFucam"
            :disabled="administrador !== true && projeto.situacao.item !== 15"
            >
            <template v-slot:label><div>FUCAM</div></template>
            </v-checkbox>
          </v-flex>
        </v-layout>

        <!-- Outros e Especifique -->
        <v-layout row wrap center >

          <!-- Outros -->
          <v-flex xs6 sm2 v-if="extensao.gratuito === false">
            <v-checkbox
            v-model="extensao.gratuitoOutros"
            :disabled="administrador !== true && projeto.situacao.item !== 15"
            >
            <template v-slot:label><div>Outros</div></template>
            </v-checkbox>
          </v-flex>

          <!-- Especifique -->
          <v-flex xs6 sm5 v-if="extensao.gratuito === false">
            <v-textarea
            :disabled="extensao.gratuitoOutros !== true || (administrador !== true && projeto.situacao.item !== 15)"
            label="Especifique:"
            v-model="extensao.especGratuitoOutros"
            rows="1"
            auto-grow
            counter="200"
            :rules="rules200"
            placeholder=" "
            >
            </v-textarea>
          </v-flex>

        </v-layout>

        <!-- Modalidade -->
        <v-layout row wrap center v-if="extensao.curso || extensao.oficina">
          <v-flex xs12>
            <v-radio-group class="v-radio-group_label" v-model="extensao.modalidade" label="Modalidade"
            :disabled="administrador !== true && projeto.situacao.item !== 15"
            >
              <v-radio label="Presencial" value="P" ></v-radio>
              <v-radio label="Semipresencial" value="S" ></v-radio>
              <v-radio label="EAD" value="D" ></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>

        <!-- Utiliza o AVA Extensão -->
        <v-layout row wrap center v-if="extensao.curso || extensao.oficina">
          <v-flex xs12>
            <v-radio-group class="v-radio-group_label" v-model="extensao.utilizaAvaExtensao" label="Utiliza o AVA Extensão"
              :disabled="administrador !== true && projeto.situacao.item !== 15"
            >
              <v-radio label="Sim" :value="true" ></v-radio>
              <v-radio label="Não" :value="false" ></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>

        <!-- Em caso de utilização de outro Ambiente Virtual de Aprendizagem (AVA), indique a plataforma -->
        <v-layout row wrap center v-if="extensao.curso || extensao.oficina">
          <v-flex xs12>
            <v-text-field
            label="Em caso de utilização de outro Ambiente Virtual de Aprendizagem (AVA), indique a plataforma"
            counter="100"
            :rules="AreaDeTextoRules100"
            v-model="extensao.plataforma"
            :disabled="administrador !== true && projeto.situacao.item !== 15"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <br>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" text @click="cancelar">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="editarExtensao(false)" :disabled="!formularioValido">Salvar</v-btn>
          <v-btn color="primary" text @click="editarExtensao(true)" :disabled="!formularioValido">Salvar e Avançar</v-btn>
        </v-card-actions>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import DataMenu from '@/components/c-date-menu'
import TextArea from '@/components/c-textarea'
import TooltipButton from '@/components/c-tooltip-btn'
import projetos from '@/utils/projetos'
import dates from '@/utils/dates'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjeto', 'projeto'],
  data: () => ({
    dates: dates,
    objetivosEspecificosTopicos: [],
    prazo: 30,
    extensao: {
      captacaoRecursosBensDuraveis: false,
      liberacaoCargaHoraria: false,
      vinculoEnsino: false,
      vinculoPesquisa: false,
      dtPrimeiraApresentacao: '',
      discenteCoordenador: false,
      curso: false,
      oficina: false,
      evento: false,
      gratuito: false,
      modalidade: 'P',
      plataforma: '',
      publicoAlvoInterno: '',
      publicoAlvoExterno: '',
      creditacaoGraduacao: false, // Valor inicial do radio group
      dtInicialCreditacao: null  // Valor inicial da data
    },
    listaTiposPrestacaoServicoSelecionados: [],
    listaTiposPrestacaoServico: [
      'Atendimento ao público em espaços de cultura, ciência e tecnologia',
      'Serviço eventual',
      'Atividades de propriedade intelectual',
      'Exames e laudos técnicos',
      'Atendimento jurídico',
      'Atendimento em saúde humana',
      'Atendimento em saúde animal'
    ],
    listaAtendimentoPublicoEspacosSelecionados: [],
    listaCoordenadoPor: [],
    listaTipoEvento: [],
    listaUnidades: [],
    listaDepartamentos: [],
    formularioValido: false,
    itensCampoEmpresaJunior: [
      { descricao: 'Sim', item: true },
      { descricao: 'Não', item: false }
    ],
    campoNumericoRules: [
      (input) => !isNaN(input) || 'O campo deve ser numérico',
      (input) => (input.length === 0 || Number(input) >= 0) || 'O campo não pode ter valor negativo'
    ],
    regrasBasicas: [
      (input) => !!input || 'Este campo é obrigatório'
    ],
    AreaDeTextoRules100: [
      (input) => (input == null || input.length <= 100) || 'Este campo não pode possuir mais que 100 caracteres'
    ],
    rules200: [
      (input) => input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres'
    ],
    AreaDeTextoRules500: [
      (input) => (input == null || input.length <= 500) || 'Este campo não pode possuir mais que 500 caracteres'
    ],
    AreaDeTextoRulesN1000: [
      (input) => (input == null || input.length <= 1000) || 'Este campo não pode possuir mais que 1000 caracteres'
    ],
    AreaDeTextoRules1000: [
      (input) => (input == null || input.length <= 1000) || 'Este campo não pode possuir mais que 1000 caracteres'
    ],
    AreaDeTextoRules1500: [
      (input) => (input == null || input.length <= 1500) || 'Este campo não pode possuir mais que 1500 caracteres'
    ],
    AreaDeTextoRules2000: [
      (input) => (input == null || input.length <= 2000) || 'Este campo não pode possuir mais que 2000 caracteres'
    ],
    AreaDeTextoRules3000: [
      (input) => (input == null || input.length <= 3000) || 'Este campo não pode possuir mais que 3000 caracteres'
    ],
    CargaHorariaCoordenadorAprovadaRules: [
      (input) => !isNaN(input) || 'A carga horária deve ser numérica',
      (input) => (input.length === 0 || Number(input) !== 0) || 'A carga horária não pode ser nula',
      (input) => (input.length === 0 || Number(input) > 0) || 'A carga horária não pode ser negativa'
    ]
  }),
  watch: {
    // Watcher para monitorar mudanças em extensao.creditacaoGraduacao
    'extensao.creditacaoGraduacao': function (newValue) {
      if (newValue === false) {
        // Se "Não" for selecionado, define dtInicialCreditacao como null
        this.extensao.dtInicialCreditacao = null
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['administrador'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    cancelar: function () {
      this.$router.push({name: 'ExtensaoProjeto', params: {idProjeto: this.idProjeto}})
    },
    editarExtensao: function (avancar) {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando informações de extensão.' })
      this.extensao.objetivosEspecificos = ''
      for (let item in this.objetivosEspecificosTopicos) {
        this.extensao.objetivosEspecificos += this.objetivosEspecificosTopicos[item].nome
        if (item < this.objetivosEspecificosTopicos.length - 1) {
          this.extensao.objetivosEspecificos += ';;'
        }
      }

      // Verificações para Prestações de Serviço.
      if (this.extensao.prestacaoServico === true) {
        // Tipo de Prestação de Serviço (Atendimento ao público em espaços de cultura, ciência e tecnologia)
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) {
          this.extensao.atendimentoPublicoEspacos = 'S'
        } else {
          this.extensao.atendimentoPublicoEspacos = 'N'
        }
        // Tipo de Prestação de Serviço (Serviço eventual)
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) {
          this.extensao.servicoEventual = 'S'
        } else {
          this.extensao.servicoEventual = 'N'
        }
        // Tipo de Prestação de Serviço (Atividades de propriedade intelectual)
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) {
          this.extensao.atividadesPropriedadeIntelectual = 'S'
        } else {
          this.extensao.atividadesPropriedadeIntelectual = 'N'
        }
        // Tipo de Prestação de Serviço (Exames e laudos técnicos)
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Exames e laudos técnicos')) {
          this.extensao.examesLaudosTecnicos = 'S'
        } else {
          this.extensao.examesLaudosTecnicos = 'N'
        }
        // Tipo de Prestação de Serviço (Atendimento jurídico)
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Atendimento jurídico')) {
          this.extensao.atendimentoJuridico = 'S'
        } else {
          this.extensao.atendimentoJuridico = 'N'
        }
        // Tipo de Prestação de Serviço (Atendimento em saúde humana)
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) {
          this.extensao.atendimentoSaudeHumana = 'S'
        } else {
          this.extensao.atendimentoSaudeHumana = 'N'
        }
        // Tipo de Prestação de Serviço (Atendimento em saúde animal)
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) {
          this.extensao.atendimentoSaudeAnimal = 'S'
        } else {
          this.extensao.atendimentoSaudeAnimal = 'N'
        }
        // Atendimento ao público em espaços de cultura, ciência e tecnologia (Espaços e Museus Culturais)
        if (this.listaAtendimentoPublicoEspacosSelecionados.includes('Espaços e Museus Culturais')) {
          this.extensao.espacosMuseusCulturais = 'S'
        } else {
          this.extensao.espacosMuseusCulturais = 'N'
        }
        // Atendimento ao público em espaços de cultura, ciência e tecnologia (Espaços e Museus de Ciência e Tecnologia)
        if (this.listaAtendimentoPublicoEspacosSelecionados.includes('Espaços e Museus de Ciência e Tecnologia')) {
          this.extensao.espacosMuseusCT = 'S'
        } else {
          this.extensao.espacosMuseusCT = 'N'
        }
        // Atendimento ao público em espaços de cultura, ciência e tecnologia (Cines-clube)
        if (this.listaAtendimentoPublicoEspacosSelecionados.includes('Cines-clube')) {
          this.extensao.cinesClube = 'S'
        } else {
          this.extensao.cinesClube = 'N'
        }
        // Atendimento ao público em espaços de cultura, ciência e tecnologia (Outros)
        if (this.listaAtendimentoPublicoEspacosSelecionados.includes('Outros')) {
          this.extensao.outrosEspacos = 'S'
        } else {
          this.extensao.outrosEspacos = 'N'
        }

        // Limpa campos caso o tipo "Atendimento ao público em espaços de cultura, ciência e tecnologia" não seja escolhido.
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia') === false) {
          this.listaAtendimentoPublicoEspacosSelecionados = []
        }

        // Limpa campos caso o tipo "Serviço eventual" não seja escolhido.
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual') === false) {
          this.extensao.numAssessorias = null
          this.extensao.numConsultorias = null
          this.extensao.numCuradorias = null
          this.extensao.numOutrosServicos = null
        }

        // Limpa campos caso o tipo "Atividades de propriedade intelectual" não seja escolhido.
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual') === false) {
          this.extensao.numPatentesModelos = null
          this.extensao.numMarcasSoftwares = null
          this.extensao.numTransferenciaTecnologia = null
          this.extensao.numDireitosAutorais = null
        }

        // Limpa campos caso o tipo "Exames e laudos técnicos" não seja escolhido.
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Exames e laudos técnicos') === false) {
          this.extensao.numLaudosEmitidos = null
        }

        // Limpa campos caso o tipo "Atendimento jurídico" não seja escolhido.
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Atendimento jurídico') === false) {
          this.extensao.numAtendimentosJuridicos = null
        }

        // Limpa campos caso o tipo "Atendimento em saúde humana" não seja escolhido.
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana') === false) {
          this.extensao.numConsultasAmbulatoriais = null
          this.extensao.numConsultasEmergencia = null
          this.extensao.numInternacoes = null
          this.extensao.numCirurgias = null
          this.extensao.numExamesLaboratoriais = null
          this.extensao.numExamesComplementares = null
          this.extensao.numOutrosAtendimentosSH = null
        }

        // Limpa campos caso o tipo "Atendimento em saúde animal" não seja escolhido.
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal') === false) {
          this.extensao.numAtendimentosVeterinarios = null
          this.extensao.numInternacoesVeterinarias = null
          this.extensao.numCirurgiasVeterinarias = null
          this.extensao.numExamesVeterinaria = null
        }
      }

      // Limpa campos caso a opção "Envolve captação de recursos financeiros ou bens duráveis" seja 'Não'.
      if (this.extensao.captacaoRecursosBensDuraveis === false) {
        this.extensao.captacaoRecursosUfes = null
        this.extensao.captacaoRecursosCapes = null
        this.extensao.captacaoRecursosFest = null
        this.extensao.captacaoRecursosCnpq = null
        this.extensao.captacaoRecursosFapes = null
        this.extensao.captacaoRecursosFucam = null
        this.extensao.captacaoRecursosOutros = null
        this.extensao.especCaptacaoRecursosOutros = null
      }

      // Limpa campos caso a opção "Envolve captação de recursos financeiros ou bens duráveis" seja 'Sim', mas a opção "Outros" não seja marcada.
      if (this.extensao.captacaoRecursosBensDuraveis === true) {
        if (this.extensao.captacaoRecursosOutros === null || this.extensao.captacaoRecursosOutros === false) {
          this.extensao.especCaptacaoRecursosOutros = null
        }
      }

      // Limpa campos caso a opção "Gratuito para o público" seja 'Sim'.
      if (this.extensao.gratuito === true) {
        this.extensao.gratuitoUfes = null
        this.extensao.gratuitoFest = null
        this.extensao.gratuitoFucam = null
        this.extensao.gratuitoOutros = null
        this.extensao.especGratuitoOutros = null
      }

      // Limpa campos caso a opção "Gratuito para o público" seja 'Não', mas a opção "Outros" não seja marcada.
      if (this.extensao.gratuito === false) {
        if (this.extensao.gratuitoOutros === null || this.extensao.gratuitoOutros === false) {
          this.extensao.especGratuitoOutros = null
        }
      }

      // Limpa campos caso a opção "Envolve liberação de carga horária do coordenador aprovada em Departamento/Centro/Setor de lotação" seja 'Não'.
      if (this.extensao.liberacaoCargaHoraria === false) {
        this.extensao.cargaHorariaCoordenadorAprovada = null
      }

      projetos.postExtensao(this.idProjeto, this.extensao)
      .then(response => {
        this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        if (avancar === false) {
          // this.$router.push({name: 'ExtensaoProjeto', params: {idProjeto: this.idProjeto}})
        } else {
          this.$router.push({name: 'IntegrantesProjeto', params: {idProjeto: this.idProjeto}})
        }
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando informações de extensão.' })
      })
    },
    opcoesTabelaEstruturada: function (codTabela, aqui, atributo) {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
      projetos.getOpcoesTabelaEstruturada(codTabela)
      .then(response => {
        aqui[atributo] = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
      })
    }
  },
  mounted () {
    this.opcoesTabelaEstruturada(990, this, 'listaCoordenadoPor')
    this.opcoesTabelaEstruturada(6028, this, 'listaTipoEvento')

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' })
    projetos.getExtensaoDoProjeto(this.idProjeto)
    .then(response => {
      this.extensao = response.data

      let aux = this.extensao.objetivosEspecificos.split(';;')
      for (let item in aux) {
        this.objetivosEspecificosTopicos.push({id: item, nome: aux[item]})
      }

      this.dataPrimeiraApresentacaoFormatada = this.dates.format(this.extensao.dtPrimeiraApresentacao)

      // Tipo de Prestação de Serviço (Atendimento ao público em espaços de cultura, ciência e tecnologia)
      if (this.extensao.atendimentoPublicoEspacos === 'S') {
        this.listaTiposPrestacaoServicoSelecionados.push('Atendimento ao público em espaços de cultura, ciência e tecnologia')
      }

      // Tipo de Prestação de Serviço (Serviço eventual)
      if (this.extensao.servicoEventual === 'S') {
        this.listaTiposPrestacaoServicoSelecionados.push('Serviço eventual')
      }

      // Tipo de Prestação de Serviço (Atividades de propriedade intelectual)
      if (this.extensao.atividadesPropriedadeIntelectual === 'S') {
        this.listaTiposPrestacaoServicoSelecionados.push('Atividades de propriedade intelectual')
      }

      // Tipo de Prestação de Serviço (Exames e laudos técnicos)
      if (this.extensao.examesLaudosTecnicos === 'S') {
        this.listaTiposPrestacaoServicoSelecionados.push('Exames e laudos técnicos')
      }

      // Tipo de Prestação de Serviço (Atendimento jurídico)
      if (this.extensao.atendimentoJuridico === 'S') {
        this.listaTiposPrestacaoServicoSelecionados.push('Atendimento jurídico')
      }

      // Tipo de Prestação de Serviço (Atendimento em saúde humana)
      if (this.extensao.atendimentoSaudeHumana === 'S') {
        this.listaTiposPrestacaoServicoSelecionados.push('Atendimento em saúde humana')
      }

      // Tipo de Prestação de Serviço (Atendimento em saúde animal)
      if (this.extensao.atendimentoSaudeAnimal === 'S') {
        this.listaTiposPrestacaoServicoSelecionados.push('Atendimento em saúde animal')
      }

      // Atendimento ao público em espaços de cultura, ciência e tecnologia (Espaços e Museus Culturais)
      if (this.extensao.espacosMuseusCulturais === 'S') {
        this.listaAtendimentoPublicoEspacosSelecionados.push('Espaços e Museus Culturais')
      }

      // Atendimento ao público em espaços de cultura, ciência e tecnologia (Espaços e Museus de Ciência e Tecnologia)
      if (this.extensao.espacosMuseusCT === 'S') {
        this.listaAtendimentoPublicoEspacosSelecionados.push('Espaços e Museus de Ciência e Tecnologia')
      }

      // Atendimento ao público em espaços de cultura, ciência e tecnologia (Cines-clube)
      if (this.extensao.cinesClube === 'S') {
        this.listaAtendimentoPublicoEspacosSelecionados.push('Cines-clube')
      }

      // Atendimento ao público em espaços de cultura, ciência e tecnologia (Outros)
      if (this.extensao.outrosEspacos === 'S') {
        this.listaAtendimentoPublicoEspacosSelecionados.push('Outros')
      }
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' })
    })

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' })
    projetos.getUnidadesExtensao()
    .then(response => {
      this.listaUnidades = response.data
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' })
    })

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' })
    projetos.getPrazoDias(this.idProjeto)
    .then(response => {
      this.prazo = response.data
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' })
    })
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-date-menu': DataMenu,
    'c-textarea': TextArea,
    'c-tooltip-btn': TooltipButton
  }
}
</script>
<style>
  .labelObjetivosEspecificos {
    color: #646464;
    font-size: 16px;
    padding-left: 0px;
  }
  .listObjetivosEspecificos {
    color: gray;
    font-size: 16px;
    padding-left: 0px;
  }
</style>

<style lang="css" scoped>

</style>

<style lang="css">

  .center {
    text-align: center;
  }

  #label {
    font-size: 10pt;
  }

  .tipoPrestacaoServico {
    font-size: 1.10em;
    margin-top: 1em;
  }

  .alerta {
    font-size: 0.85em;
  }

</style>

<style scoped>

  .alertaPrazo {
    margin: 1.0em 0 2.0em 0;
    font-size: 0.85em;
    text-align: justify;
  }

</style>



// WEBPACK FOOTER //
// editar-extensao.vue?e5009286